/**
 * Created by Yair on 27/12/2016.
 */
import * as uploadApi from 'api/upload-api';
import profile from 'config/profile';
import filesize from 'filesize';
import {splitFile} from 'utils/file-utils';
import store from 'store';
import {assetError, assetPercentComplete, assetProgress, uploadAssetDone} from 'actions/asset-actions';
import {track} from 'utils/analytics'
import _ from 'lodash';
import * as assetApi from 'api/asset-api';
import realTime from 'utils/realtime';

class FileUpload {
    constructor(params, user) {
        Object.assign(this, params);
        this.user = user;
        this.uploadWorkerMessageBound = this.uploadWorkerMessage.bind(this);

    }

    start() {
        this.uploadMetadata().then(response => {
            store.dispatch(assetProgress(this.tempUUID, 'UPLOADING', response.data.assetUUID));
            this.uploadFile(response.data);
        });
    }

    uploadMetadata() {
        const params = {
            assetUUID: this.tempUUID,
            creationDate: this.creationDate,
            fileName: this.fileName,
            isAudio: this.isAudio,
            isVideo: this.isVideo,
            ownerUserDbId: this.ownerUserDbId,
            privacy: this.privacy,
            programmersIds: this.programmersIds,
            title: this.title,
            type: this.type
        };
        return uploadApi.uploadMetadata(params).then((response) => {
            this.assetUUID = response.data.assetUUID;
            store.dispatch(assetProgress(this.tempUUID, 'UPLOADING', response.data.assetUUID));
            return response;
        });
    }

    uploadFile(data) {
        this.uploadWorker = new Worker('/javascripts/upload.js?_=' + new Date().getTime());
        this.uploadWorker.onerror = this.uploadWorkerFailure.bind(this);
        this.uploadWorker.addEventListener('message', this.uploadWorkerMessageBound);
        let params = {};
        params.apiUrl = profile.apiUrl;
        params.assetUUID = data.assetUUID;
        params.tempUUID = this.tempUUID;
        params.uploadId = data.uploadId;
        params.fileName = this.fileName;
        params.caption = this.caption;
        params.privacy = this.privacy;
        params.organization = this.selectedOrganization;
        params.programmersIds = this.programmersIds;
        params.ownerUserDbId = this.userId;
        params.title = this.title;
        params.keywords = this.keywords;
        params.attribution = this.attribution;
        params.attributionMode = this.attributionMode;
        // TODO: detect when need to re-upload and set this parameter accordingly, 0 by default
        params.MAX_RETRIES = 3;
        this.uploadWorker.postMessage(JSON.stringify(params));

    }

    abort() {
        if (this.uploadWorker) {
            this.uploadWorker.terminate();
        }
    }

    uploadWorkerMessage(e) {
        var message = JSON.parse(e.data);
        const file = this.file;
        const size = filesize(file.size, {unix: true});
        const type = file.type.split('/')[0];

        if ('init' === message.type) {
            // after init done - start sending file
            this.uploadWorker.postMessage(splitFile(file));

        } else if ('done' === message.type) {
            // after file successfully uploaded
            this.uploadWorkerDone(message.data, { size, type});
        } else if ('progress' === message.type) {
            // after each file chunk sent
            var step = JSON.parse(message.data);
            store.dispatch(assetPercentComplete(step.assetUUID, step.progress));
            console.log(step);
        } else if ('fail' === message.type) {
            track('Upload File Error', {...message.data, ...this.user});
            this.uploadWorkerFailure(message.data);
        } else if ('log' === message.type) {
            console.info('log:', message.data);
        } else if ('debug' === message.type) {
            console.debug(JSON.parse(message.data));
            alert(message.data);
        } else {
            console.log(message);
        }
    }

    listenOnAsset(uuid, user, selectedOrganization, analyticsData) {
        const listen = realTime.listenOnAsset.bind(realTime, uuid);
        const getAsset = assetApi.getAsset.bind(null, uuid, selectedOrganization);

        realTime.init().then(listen).then(getAsset).then((asset) => {
            store.dispatch(uploadAssetDone(uuid, asset));
            if (!_.isEmpty(analyticsData)) {
                track('Upload File', Object.assign(analyticsData, user));
            }
            realTime.cancelListenOnAsset(uuid);
        }).catch(o => {
            track('Process File Error', { error: o.error, message: o.message, ...user});
            store.dispatch(assetProgress(uuid, 'FAILED'));
            FileUpload.markError(uuid, 'process', 'Error in processing phase');
            console.error("Error listening to asset changes", { error: o.error, message:o.message, ...user});
        });
    }


    static markError(assetId, errorCode, errorMessage) {
        store.dispatch(assetError(assetId, errorCode, errorMessage));
    }

    uploadWorkerDone(data, analyticsData) {
        console.log('***', data.assetUUID, this.assetUUID);
        store.dispatch(assetProgress(data.assetUUID, 'PROCESSING'));
        this.listenOnAsset(this.assetUUID, this.user, this.selectedOrganization, analyticsData);
    }

    uploadWorkerFailure(e) {
        if (_.isObject(e) && e.message) {    // `e` - event from worker
            FileUpload.markError(e.id, 'upload', e.message);
            console.error('uploadWorkerFailure: ', e.message);
            if (e.bug) {
                alert(e.bug.code)
            }
        } else if (_.isString(e)) {
            FileUpload.markError(e.id, 'upload', e.message);
            console.error('uploadWorkerFailure:', e);
        }
        // alert(e.message);
        store.dispatch(assetProgress(e.id, 'FAILED'));
    }
}

export default FileUpload;
